module.exports = __webpack_public_path__ + "static/img/webPermit.407c412.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/webPermit.png
// module id = bM11
// module chunks = 1